import { PageProductTemplateQuery } from 'graphql-types';
import React from 'react';
import { graphql } from 'gatsby';
import { SEO } from '../components/seo/Seo';
import { Sections, SectionsType } from '../components/section/Sections';

interface Props {
  data: PageProductTemplateQuery;
}

const PageProductTemplate: React.FC<Props> = ({ data }) => {
  return (
    <>
      <SEO rawMeta={data?.sanityPageProduct?._rawMetadata} />
      <Sections sections={data?.sanityPageProduct?.sectionsProductList as SectionsType} />
    </>
  );
};

export function Head() {
  return (
    <>
      <script
        type="application/ld+json"
        id="gtagManager"
        src="https://www.googletagmanager.com/gtag/js?id=G-CPD641WMLY"
      ></script>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-CPD641WMLY', {'send_page_view':false});
      gtag('config', 'GTM-KJSJGRLX', {'send_page_view':false});
`,
        }}
      ></script>
    </>
  );
}

export default PageProductTemplate;

export const PAGEPRODUCTTEMPLATE = graphql`
  query PageProductTemplate($id: String) {
    sanityPageProduct(id: { eq: $id }) {
      countrySettings {
        ...countrySettingsFragment
      }
      _rawMetadata(resolveReferences: { maxDepth: 10 })
      id
      _rawPageProductSlug(resolveReferences: { maxDepth: 10 })
      sectionsProductList {
        ...titleSectionFragment
        ...centerTextSectionFragment
        ...newsletterSectionFragment
        ...formSectionFragment
        ...valuesSectionFragment
        ...videoTitleTextSectionFragment
        ...technoCardSectionFragment
        ...expertiseCardSectionFragment
        ...productCardSectionFragment
        ...textButtonImgBgSectionFragment
        ...textPortraitSectionFragment
        ...imageSectionFragment
        ...adaptativeSectionFragment
        ...mapSectionFragment
        ...commentsSectionFragment
        ...partnerSectionFragment
        ...columnsSectionFragment
        ...exampleSectionFragment
        ...advantageProductSectionFragment
        ...buttonSectionFragment
      }
    }
  }
`;
